import React from 'react'
import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import Sponsorsite from './Containers/Sponsorsite'
import { BrowserRouter, HashRouter } from 'react-router-dom'
require('dotenv').config()

function App() {
  return (
    <HashRouter>
      <Sponsorsite />
    </HashRouter>
  )
}

export default App
